import React, { useState, useEffect,useContext } from 'react';
import { X, Check, Users, CreditCard } from 'lucide-react';

import { useNavigate } from 'react-router-dom';

import PaymentSheet from './PaymentSheet';

import AppContext from '../../context/AppContext';
const SuccesBottomSheet = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { isSplashVisible, isLoading,id,bottom, setBottom } = useContext(AppContext);

  const navigate=useNavigate()

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <div>
      {/* Overlay avec effet de flou */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 transition-opacity duration-300"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Bottom Sheet avec animation */}
      <div className={`
        fixed left-0 right-0 bottom-0 z-50 
        transform transition-transform duration-500 ease-out
        ${isOpen ? 'translate-y-0' : 'translate-y-full'}
      `}>
        <div className="bg-white rounded-t-3xl shadow-2xl max-h-[90vh] overflow-y-auto">
          {/* Barre de poignée */}
          <div className="flex justify-center pt-4">
            <div className="w-12 h-1 bg-gray-200 rounded-full" />
          </div>

          <div className="p-6">
            {/* En-tête avec bouton de fermeture */}
            <div className="flex justify-between items-center mb-6">
              <button
                onClick={() => setIsOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
              >
                <X className="w-6 h-6 text-gray-500" />
              </button>
            </div>

            {/* Icône de succès */}
            <div className="flex justify-center mb-6">
              <div className="bg-green-100 rounded-full p-4">
                <Check className="w-12 h-12 text-green-600" />
              </div>
            </div>

            {/* Message de succès */}
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-3">
                Parfait ! 🎉
              </h2>
              <p className="text-lg text-gray-600">
                Que voulez-vous faire maintenant ?
              </p>
            </div>

            {/* Boutons d'action */}
            <div className="space-y-4">
              <a
               onClick={() => {
                console.log("en route poyur rediriger")

                // onClick={() => navigate("/GroupeListe")}
                setBottom(null)

                navigate("/GroupeListe")
              }}
             href="https://t.me/KappelavendeurBot?startgroup=true&start=id"
                className="w-full bg-blue-600 text-white py-4 px-6 rounded-xl font-medium hover:bg-blue-700 transform hover:-translate-y-0.5 transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center space-x-3"
              >
                <Users className="w-6 h-6" />
                <span>Ajouter un groupe ou canal</span>
              </a>
              
              <button
                onClick={() =>{
                  
                  setBottom(<PaymentSheet/>)

                } }
                className="w-full bg-white text-blue-600 py-4 px-6 rounded-xl font-medium border-2 border-blue-600 hover:bg-blue-50 transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center space-x-3"
              >
               
                <span>Ajouter autre méthode de paiement</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccesBottomSheet;